var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ol><li ng-repeat=\"wahl in vm.parameter[vm.key].wert\">{{ wahl.kbez }}\n(<span ng-if=\"wahl.freitext\">mit</span><span ng-if=\"!wahl.freitext\">ohne</span>\nFreitext)</li></ol>");;return buf.join("");
}